import classes from "./RoundedEdgeButton.module.scss";

const RoundedEdgeButton = ({ type = "button", children, onClick, disabled, className }) => {
  return (
    <button
      type={type}
      className={`${classes.roundedEdgeButton} ${disabled ? classes.disabled : ""
        } ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default RoundedEdgeButton;
